import type { Option } from '@/components/ui/combobox/combobox-popover';

export const AppraisalStatus = {
  Draft: 'DRAFT',
  PendingReview: 'PENDING_REVIEW',
  Sent: 'OFFER_SENT',
  Accepted: 'OFFER_ACCEPTED',
  Completed: 'COMPLETED',
  Rejected: 'DENIED',
  Expired: 'EXPIRED',
  Closed: 'CLOSED',
  Abandoned: 'ABANDONED',
} as const;

export const STATUS_LABELS: Record<AppraisalStatusType, string> = {
  DRAFT: 'Draft',
  PENDING_REVIEW: 'Pending Review',
  OFFER_SENT: 'Offer sent',
  OFFER_ACCEPTED: 'Offer accepted',
  COMPLETED: 'Completed',
  DENIED: 'Rejected',
  EXPIRED: 'Expired',
  CLOSED: 'Closed',
  ABANDONED: 'Abandoned',
};

export type AppraisalStatusType =
  (typeof AppraisalStatus)[keyof typeof AppraisalStatus];

export const AppraisalOfferStatus = {
  NoAvailableOffers: 'NO_AVAILABLE_OFFERS',
  OffersAvailable: 'OFFERS_AVAILABLE',
  OffersAccepted: 'OFFERS_ACCEPTED',
} as const;

export type AppraisalOfferStatusType =
  (typeof AppraisalOfferStatus)[keyof typeof AppraisalOfferStatus];

export const APPRAISAL_OFFER_STATUS_LABELS: Record<
  AppraisalOfferStatusType,
  string
> = {
  NO_AVAILABLE_OFFERS: 'No Offers',
  OFFERS_AVAILABLE: 'Offers Available',
  OFFERS_ACCEPTED: 'Accepted',
};

export const AppraisalSource = {
  Recurrent: 'recurrent',
} as const;

export type AppraisalSourceType =
  (typeof AppraisalSource)[keyof typeof AppraisalSource];

export type OfferType = 'CASH_OFFER' | 'TRADE_IN_OFFER' | 'RECURRENT_OFFER';

export type OfferForm = {
  offer_type: OfferType;
  offer_amount_dollars: string;
};

// Debt Type options
export const DEBT_TYPE_OPTIONS: Option<string>[] = [
  {
    value: 'LOAN',
    label: 'Loan',
  },
  {
    value: 'LEASE',
    label: 'Lease',
  },
  {
    value: 'NONE',
    label: 'None',
  },
];

// Tire Condition options
export const TIRE_CONDITION_OPTIONS: Option<string>[] = [
  {
    value: 'all_good',
    label: 'All good, plenty of tread',
  },
  {
    value: 'one_to_two_low_tread',
    label: '1-2 tires with low tread or damage',
  },
  {
    value: 'three_or_more_low_tread',
    label: '3-4 tires with low tread or damage',
  },
];

// Appraisal Creation Step options
export const APPRAISAL_CREATION_STEP_OPTIONS: Option<string>[] = [
  {
    value: 'VEHICLE_DETAILS',
    label: 'Vehicle Details',
  },
  {
    value: 'VEHICLE_CONDITION',
    label: 'Vehicle Condition',
  },
  {
    value: 'CONTACT',
    label: 'Contact',
  },
  {
    value: 'COMPLETED',
    label: 'Completed',
  },
];
